import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import AppIcon from './AppIcon';
import { FaUser, FaSignOutAlt, FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const { user, userProfile, logout } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    const result = await logout();
    if (result.success) {
      navigate('/');
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo and Brand */}
        <Link to="/" className="navbar-brand" onClick={closeMenu}>
          <AppIcon size={35} />
          <span className="brand-text">Nurturing Inner Love</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="navbar-menu">
          <Link to="/" className="navbar-link">Home</Link>
          <Link to="/chapters" className="navbar-link">Chapters</Link>
          <Link to="/media" className="navbar-link">Media</Link>

          {user ? (
            <div className="navbar-user">
              {userProfile?.isAdmin && (
                <Link to="/admin" className="navbar-link admin-link">Admin</Link>
              )}
              <Link to="/settings" className="navbar-link">Settings</Link>
              <div className="user-info">
                <FaUser size={18} />
                <span className="user-email">{user.email}</span>
                <button onClick={handleLogout} className="logout-btn">
                  <FaSignOutAlt size={16} />
                </button>
              </div>
            </div>
          ) : (
            <div className="navbar-auth">
              <Link to="/login" className="btn btn-outline">Login</Link>
              <Link to="/signup" className="btn btn-primary">Sign Up</Link>
            </div>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button className="mobile-menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
        </button>

        {/* Mobile Navigation */}
        <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" className="mobile-link" onClick={closeMenu}>Home</Link>
          <Link to="/chapters" className="mobile-link" onClick={closeMenu}>Chapters</Link>
          <Link to="/media" className="mobile-link" onClick={closeMenu}>Media</Link>

          {user ? (
            <>
              {userProfile?.isAdmin && (
                <Link to="/admin" className="mobile-link admin-link" onClick={closeMenu}>
                  Admin Panel
                </Link>
              )}
              <Link to="/settings" className="mobile-link" onClick={closeMenu}>Settings</Link>
              <div className="mobile-user-info">
                <span className="mobile-user-email">{user.email}</span>
                <button onClick={() => { handleLogout(); closeMenu(); }} className="mobile-logout-btn">
                  Logout
                </button>
              </div>
            </>
          ) : (
            <div className="mobile-auth">
              <Link to="/login" className="mobile-link" onClick={closeMenu}>Login</Link>
              <Link to="/signup" className="mobile-link primary" onClick={closeMenu}>Sign Up</Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
